import * as React from 'react';
import { observer } from 'mobx-react';
import { PageGiveViewModel } from './page-give-view-model';
import { FormControl } from '../../components/form-control/form-control';
import { FormControlSplitButton } from '../../components/split-button';
import { ReferenceFields } from '../../components/reference-fields/reference-fields';
import { RecurringPaymentFields, OneTimePaymentFields } from './page-give';

export { PageGiveViewModel };

@observer
export class PageGiveDollars extends React.Component<{
    vm: PageGiveViewModel;
}> {

    render() {
        const { vm } = this.props;
        const {
            giftType,
            giftTypeOptions,
            isRecurring,
            referenceFieldsViewModel,
            paymentLabel: { NounSentenceCase },
            minEndDate,
            merchantInfo,
            recurringSelectorIsVisible,
            fundVisibility,
            lineItemsViewModel,
            hasLineItems,
            amount,
        } = vm;

        const { OneTimeFutureGiftEnabled: oneTimeFutureGiftEnabled } = merchantInfo;

        return (
            <div>
                {recurringSelectorIsVisible && (
                    <FormControl label={`${NounSentenceCase} type`}>
                        <FormControlSplitButton
                            field={giftType}
                            options={giftTypeOptions}
                            uniformWidth={true}
                            ariaLabel={`${NounSentenceCase} type`}
                            acceptanceTestTargetId="Gift type"
                        />
                    </FormControl>
                )}
                {isRecurring && (
                    <RecurringPaymentFields
                        {...this.props.vm}
                        minEndDate={minEndDate}
                        yearlyRecurringGivingEnabled={
                            vm.merchantInfo.HasYearlyRecurringGivingEnabled
                        }
                        semiYearlyRecurringGivingEnabled={
                            vm.merchantInfo.HasSemiYearlyRecurringGivingEnabled
                        }
                        quarterlyRecurringGivingEnabled={
                            vm.merchantInfo.HasQuarterlyRecurringGivingEnabled
                        }
                        payerSpecifiedRecurringEndDateEnabled={
                            vm.merchantInfo.PayerSpecifiedRecurringEndDateEnabled
                        }
                    />
                )}
                <ReferenceFields 
                    vm={referenceFieldsViewModel}
                    fundVisibility={fundVisibility} 
                    hasLineItems={hasLineItems} 
                    lineItemsViewModel={lineItemsViewModel}
                    amount={amount.value}
                    isRecurring={isRecurring}
                    isOneTimeFutureGiftEnabled={oneTimeFutureGiftEnabled}
                />

                {!isRecurring && oneTimeFutureGiftEnabled && (
                    <OneTimePaymentFields {...this.props.vm} minEndDate={minEndDate} />
                )}
            </div>
        );
    }
}
